import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
const slides = [{
  image: 'https://cdn.magicpatterns.com/uploads/4Zo4WEP5g3ocb6GeVDBxHS/sl_1.jpg',
  title: 'Excellence in Education Since 1979',
  subtitle: 'Faith • Knowledge • Morality • Excellence'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/95zinHu4ASb39rzPkhHzwq/sl_2.jpg',
  title: 'Nurturing Future Leaders',
  subtitle: 'Empowering minds through quality education'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/rek433YCdYwmj8LUX55neN/sl_3.jpg',
  title: 'A Legacy of Academic Achievement',
  subtitle: 'Building character, inspiring excellence'
}];
export function HeroSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [prevSlideIndex, setPrevSlideIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      goToSlide((currentSlide + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [currentSlide]);
  const goToSlide = (index: number) => {
    setPrevSlideIndex(currentSlide);
    setCurrentSlide(index);
  };
  const nextSlide = () => {
    goToSlide((currentSlide + 1) % slides.length);
  };
  const prevSlide = () => {
    goToSlide((currentSlide - 1 + slides.length) % slides.length);
  };
  return <section id="home" className="relative h-[calc(75vh+80px)] w-full overflow-hidden" data-id="element-149">
      {/* All slides stacked — current one animates in on top */}
      {slides.map((slide, index) => <div key={index} className="absolute inset-0 transition-opacity duration-1000 ease-in-out" style={{
      opacity: index === currentSlide ? 1 : 0,
      zIndex: index === currentSlide ? 2 : 1
    }} data-id="element-150">
          <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[6000ms] ease-out" style={{
        backgroundImage: `url(${slide.image})`,
        transform: index === currentSlide ? 'scale(1.05)' : 'scale(1)'
      }} data-id="element-151" />
          <div className="absolute inset-0 bg-gradient-to-r from-primary/80 via-primary/60 to-transparent" data-id="element-152" />
        </div>)}

      {/* Text Content */}
      <div className="relative z-10 h-full flex items-center" data-id="element-153">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-154">
          <motion.div key={currentSlide} initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="max-w-3xl" data-id="element-155">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-156">
              {slides[currentSlide].title}
            </h1>
            <p className="text-xl md:text-2xl text-white/90 font-light" data-id="element-157">
              {slides[currentSlide].subtitle}
            </p>
          </motion.div>
        </div>
      </div>

      {/* Navigation Arrows */}
      <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 z-10 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white p-3 rounded-full transition-all border border-white/20" data-id="element-158">
        <ChevronLeft size={24} data-id="element-159" />
      </button>
      <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 z-10 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white p-3 rounded-full transition-all border border-white/20" data-id="element-160">
        <ChevronRight size={24} data-id="element-161" />
      </button>

      {/* Dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3 z-10" data-id="element-162">
        {slides.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-3 h-3 rounded-full transition-all ${index === currentSlide ? 'bg-white w-8' : 'bg-white/50'}`} data-id="element-163" />)}
      </div>
    </section>;
}